// 正規表現定数

export const REG_EXP = {
  url: /(http(s)?:\/\/[a-zA-Z0-9-.!'()*;/?:@&=+$,%_#\u3000-\u30FE\u4E00-\u9FA0\uFF01-\uFFE3]+)/gi,
  tagSymbol: /</gi,
  uniqueTagSymbol: /\$###\$/gi,
  closeTag: /<\/(.*?)>/gi,
  escapedCloseTag: /&lt;\/(.*?)&gt;/gi,
  uniqueCloseTag: /\$\*\*\/(.*?)\*\*\$/gi,
  quotationLine: /^(&gt;)(.*?)$|^(&gt;)(.*?)\n/gim,
  mentionSymbol: /@\[(.*?):(.*?)\]/gi,
  taskTagSymbol: /#\[(.*?):(.*?)\]/gi
}


// 拡張子判定定数
export const IMAGE_TYPES = [
  'apng',
  'avif',
  'gif',
  'jpg',
  'jpeg',
  'jfif',
  'pjpeg',
  'pjp',
  'png',
  'svg',
  'webp',
  'bmp',
  'ico',
  'cur',
  'tif',
  'tiff'
]

export const VIDEO_TYPES = [
  'avi',
  'mov',
  'qt',
  'mp4',
  'webm',
  'wmv'
]

export const BYTE_UNITS = {
  kb: 1024,
  mb: 1024 ** 2
}

// 各種機能に対して作成権限を持つroleの名称配列
export const CREATABLE_ROLES = [
  'officeMaster',
  'user'
]
